<script setup lang="ts">
import type { NovaButtonGNBProps } from './NovaButtonGNB.types'

defineProps<NovaButtonGNBProps>()
</script>

<template>
  <button class="nova-button-gnb" type="button">
    <NovaIcon :icon="icon" class="icon" />
  </button>
</template>

<style scoped lang="scss">
.nova-button-gnb {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;

  .icon {
    font-size: 22px !important;
    color: $color-gray-1000;
  }

  @include mobile {
    width: 22px;
    height: 22px;

    .icon {
      font-size: 22px !important;
    }
  }
}
</style>
